export default function NewsletterSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-6">
          <i className="ri-mail-send-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          订阅酷漫屋<span className="text-accent-500">更新通知</span>
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          第一时间获取最新漫画上架通知、热门推荐和独家活动信息，精彩不错过
        </p>
        <form
         
          action="http://lst56.com/"
          method="POST"
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="请输入您的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder-foreground-400 outline-none focus:border-accent-400 transition-colors duration-200"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
          <div className="contact-spam-field">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
        </form>
      </div>
    </section>
  );
}